import type { ChipColor } from '@heidi/design-system/chip';
import type {
  StatusIndicatorMarkerColor,
  StatusIndicatorStatus,
} from '@heidi/design-system/status-indicator';
import { ClinicalTaskCategory, ClinicalTaskStatus } from '@heidi/schema/ml-scribe';

/**
 * Statuses that use a `StatusIndicator`. To do is the session list's empty
 * circle, which is not one of those glyphs — `ClinicalTaskStatusIcon` draws it.
 */
export const clinicalTaskStatusIndicator: Record<
  Exclude<ClinicalTaskStatus, ClinicalTaskStatus.todo>,
  StatusIndicatorStatus
> = {
  [ClinicalTaskStatus.in_progress]: 'in-progress',
  [ClinicalTaskStatus.done]: 'done',
  [ClinicalTaskStatus.archived]: 'archive',
};

/**
 * Chip hover / open fill for statuses that have a coloured mark. To do is an
 * unfilled slot, so it has no tint. Shared by the status selector and the
 * tasks-page enum cell.
 */
export const clinicalTaskStatusChipColor: Partial<Record<ClinicalTaskStatus, ChipColor>> =
  {
    [ClinicalTaskStatus.in_progress]: 'blue',
    [ClinicalTaskStatus.done]: 'yellow',
    [ClinicalTaskStatus.archived]: 'neutral',
  };

// Keeps the legacy category palette; `prescription` is red for the
// prescription-pad connotation.
export const clinicalTaskCategoryColor: Record<
  ClinicalTaskCategory,
  StatusIndicatorMarkerColor
> = {
  [ClinicalTaskCategory.order]: 'pink',
  [ClinicalTaskCategory.coordinate]: 'purple',
  [ClinicalTaskCategory.communicate]: 'orange',
  [ClinicalTaskCategory.document]: 'green',
  [ClinicalTaskCategory.action]: 'blue',
  [ClinicalTaskCategory.prescription]: 'red',
};
